export default __webpack_public_path__ + "02dde9767b8bc105fac9784e8e5afa26.svg";